import React from 'react';
import { Outlet } from 'react-router-dom';

import { withAuthentication } from '../authentication';
import { Organization, Invitations } from './pages';

const onboardingRouter = () => ({
  path: 'onboarding',
  element: <Outlet />,
  children: [
    {
      path: 'organization',
      element: withAuthentication(Organization)
    },
    {
      path: 'invitations',
      element: withAuthentication(() => <Invitations />)
    }
  ]
});

export { onboardingRouter };
